// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3rNT2","signatureButtonsRight":"ModalSign_signatureButtonsRight__3BO_l"};